import { httpGet } from '@/api/http';
import type { UseQueryReturnType } from '@tanstack/vue-query';
import type { AxiosError } from 'axios';
import { V2_FAVOURITES_CONTACTS } from '@/constants/endpoint';
import { useAuthenticatedQuery } from '@/utils/query';
import { normalizeArrayToMapByKey } from '@/utils/dataTransformationUtils';

export interface FavouriteContact {
  userUuid: string;
  contactUuid: string;
  createdDate: Date;
}

export const FAVORITES_QUERY_KEY = 'favorites';

export const favoritesQuery = {
  queryKey: [FAVORITES_QUERY_KEY],
  queryFn: () => httpGet<FavouriteContact[]>(V2_FAVOURITES_CONTACTS).then((contacts) => normalizeArrayToMapByKey(contacts, 'contactUuid')),
  refetchInterval: 600_000,
  refetchOnMount: false,
};
export const useFavorites = (): UseQueryReturnType<Map<string, { contact_uuid: string }> | undefined, AxiosError<unknown, any>> => {
  return useAuthenticatedQuery(favoritesQuery);
};
